export const countryOptions = [
    { value: "usPuerto", label: "United States and Puerto Rico" },
    { value: "colombia", label: "Colombia" },
    { value: "dominicanRepublic", label: "Dominican Republic" },
    { value: "japan", label: "Japan" },
    { value: "venezuela", label: "Venezuela" },
    { value: "mexico", label: "Mexico" },
    { value: "panama", label: "Panama" },
    { value: "nicaragua", label: "Nicaragua" },
    { value: "taiwan", label: "Taiwan" },
    { value: "southKorea", label: "South Korea" },
    { value: "other", label: "Other" },
];
